export const PAYMENT_TYPES = ['Mobile Payment','Bank Account'];